import React from 'react';
import { ManaSymbol } from './ManaSymbol';

interface SmartAdviceBoxProps {
  advice: string[];
  className?: string;
}

function renderAdviceTextWithPips(text: string) {
  const parts = text.split(/(\{[\w/]+\})/g);
  return parts.map((part, i) => {
    const match = part.match(/^\{([\w/]+)\}$/);
    if (match) {
      return (
        <ManaSymbol
          key={i}
          symbol={match[1]}
          size="sm"
          className="inline-block align-middle mx-0.5"
        />
      );
    }
    return part;
  });
}

export function renderAdviceLine(item: string, idx: number) {
  return (
    <div key={idx} className="leading-relaxed flex items-center flex-wrap gap-y-0.5 text-xs text-slate-300">
      {item.split('**').map((part, i) => {
        const isBold = i % 2 === 1;
        const content = renderAdviceTextWithPips(part);
        return isBold ? (
          <strong key={i} className="text-cyan-300 font-semibold mx-0.5">
            {content}
          </strong>
        ) : (
          <span key={i}>{content}</span>
        );
      })}
    </div>
  );
}

export function SmartAdviceBox({ advice, className = '' }: SmartAdviceBoxProps) {
  if (!advice || advice.length === 0) return null;

  return (
    <div className={`p-3 bg-cyan-950/30 border border-cyan-500/30 rounded-lg shadow-inner ${className}`}>
      <div className="flex items-center gap-2 mb-2 text-cyan-400 font-semibold text-xs tracking-wide uppercase">
        <span>Smart Sources Advice</span>
      </div>
      <div className="space-y-1.5 text-xs text-slate-300">
        {advice.map((item, idx) => renderAdviceLine(item, idx))}
      </div>
    </div>
  );
}
